import Reveal, { Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/api";

export default function About() {
  return (
    <section className="py-24 sm:py-32" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-5 relative">
          <div className="w-[80%] aspect-[3/4] max-h-[70vh] rounded-[2rem] overflow-hidden">
            <img src={IMAGES.portrait} alt="Chiara Piccioni, fitness coach" className="w-full h-full object-cover object-[48%_center]" />
          </div>
          <div className="absolute right-0 bottom-10 w-[42%] aspect-square rounded-3xl overflow-hidden border-4 border-[#F9F7F3] hidden sm:block">
            <img src={IMAGES.food} alt="Piatto equilibrato" className="w-full h-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6 lg:col-start-7">
          <Eyebrow>Chi sono</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-[1.05] mt-4">
            Ciao, sono Chiara.
          </h2>
          <div className="mt-6 space-y-4 text-[#5A625C] leading-relaxed text-[17px]">
            <p>
              Sono una fitness coach e lavoro solo con donne. Le aiuto a ritrovare il benessere e sentirsi bene nel
              proprio corpo, offrendo una ricomposizione corporea — meno grasso, più tono, più forza — senza diete
              estreme e senza allenamenti che ti lasciano solo sfinita.
            </p>
            <p>
              Il mio metodo è semplice: allenamento con i pesi progressivo, alimentazione sufficiente e bilanciata,
              e check-in video settimanali per monitorare e per aggiustare il tiro.
            </p>
            <p className="font-display italic text-2xl text-[#1E231F] leading-snug pt-2">
              «Non devi punire il tuo corpo per cambiarlo.»
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
